import { FC } from 'react';
import { Stack } from '@mui/material';

import { RouteStop } from './RouteStop';
import { IRouteStop } from './types';
import { getRouteStopVariant } from './utils';

interface IBookingRouteSingleProps {
	stops: IRouteStop[];
	/** Marks every stop time as an estimate (delay of unknown length). */
	isApproximate?: boolean;
}

/**
 * Simple route view for PRODT/LBODTFLEX.
 * Shows only departure and arrival points with times and addresses.
 */
export const BookingRouteSingle: FC<IBookingRouteSingleProps> = ({
	stops,
	isApproximate,
}) => {
	return (
		<Stack>
			{stops.map((stop, idx) => (
				<RouteStop
					key={idx}
					isApproximate={isApproximate}
					variant={getRouteStopVariant(idx, stops.length)}
					time={stop.time}
					effectiveTime={stop.effectiveTime}
					lat={stop.lat}
					lng={stop.lng}
					address={stop.address}
					addressTestId={stop.addressTestId}
				/>
			))}
		</Stack>
	);
};
